/************** UTILITY FUNCTIONS **************/
import { i18n } from "@/main";
import { logoutVue } from "@/api/apiRequests/globalApi";
import { instance } from "@/api/apiInstances/apiInstance.js";
import store from "@/store";

// export function logout() {
//   logoutVue(instance)
//     .then((response) => {
//       if (response.data) {
//         store.commit("setLogout");
//         let locale = i18n.locale;
//         if (locale === "gb") {
//           locale = "en";
//         }
//         const homepageURL = process.env.VUE_APP_BASE_URL;
//         let redirectUrl = `${homepageURL + locale}`;
//         window.location.href = redirectUrl;
//       } else {
//         //console.error("Logout API request failed:", response);
//       }
//     })
//     .catch((error) => {
//       // console.error('An error occurred during logout:', error);
//     });
// }

export function logout() {
  logoutVue(instance)
    .then((response) => {
      if (response.data) {
        store.commit("setLogout");
        let locale = i18n.locale;
        if (locale === "gb") {
          locale = "en";
        }
        // Поправи ја оваа линија:
        // const homepageURL = process.env.VUE_APP_BASE_URL;
        // let redirectUrl = `${homepageURL + locale}`;
        // window.location.href = redirectUrl;

        window.location.href = "/";
      }
    })
    .catch((error) => {
      // handle error
    });
}

// Utility function to calculate duration between two dates in minutes
export function calcDuration(date1, date2) {
  // Convert the date strings to Date objects
  const startTime = new Date(date1);
  const endTime = new Date(date2);

  // Calculate the time difference in milliseconds
  const timeDifferenceMilliseconds = endTime - startTime;

  // Convert the time difference to minutes
  const timeDifferenceMinutes = Math.floor(
    timeDifferenceMilliseconds / (1000 * 60)
  );

  //console.log("calcDuration: ", timeDifferenceMinutes)
  return timeDifferenceMinutes;
}

// Utility function to check if an object is non-empty
export function isNonEmptyObject(obj) {
  return typeof obj === "object" && obj !== null && Object.keys(obj).length > 0;
}

// Utility function to check if an array is non-empty
export function isNonEmptyArray(arr) {
  return Array.isArray(arr) && arr.length > 0;
}

export function applyTranslate(length, name) {
  let absences = length != 1 ? `${name}s` : name;
  // let absences = length > 1 ? `${name}s` : name;
  return this.$t(absences);
}

// Utility function for calculating total time for given min and max values in format HH:MM
export function calcTotalTime(minTime, maxTime) {
  // Split the time strings into hours and minutes components
  const minTimeParts = minTime.split(":");
  const maxTimeParts = maxTime.split(":");

  // Parse hours and minutes
  const minHours = parseInt(minTimeParts[0], 10);
  const minMinutes = parseInt(minTimeParts[1], 10);

  let maxHours = parseInt(maxTimeParts[0], 10);
  const maxMinutes = parseInt(maxTimeParts[1], 10);

  // Check if maxTime is on the day after
  if (maxHours < minHours) {
    maxHours += 24; // Add 24 hours to maxHours
  }

  // Calculate the time difference in minutes
  const timeDifferenceMinutes =
    (maxHours - minHours) * 60 + (maxMinutes - minMinutes);

  //console.log("totalTime in minutes:", timeDifferenceMinutes);
  return timeDifferenceMinutes;
}

// Utility function for formatting dates
export function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  //console.log("**************month:", month);
  return `${day}-${i18n.t(month)}-${year} ${hours}:${minutes}`;
}

// Utility function for short formatting dates
export function formatShortDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day}-${i18n.t(month)}-${year}`;
}

// Utility function for short formatting dates correct order of day mont year, the month is translated
export function formatStartAndEndDate(dateString) {
  const [day, month, year] = dateString.split('-');
  const date = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
  const formattedDay = date.getDate().toString().padStart(2, "0");
  const formattedMonth = date.toLocaleString("default", { month: "short" });
  const formattedYear = date.getFullYear();
  return `${formattedDay}-${i18n.t(formattedMonth)}-${formattedYear}`;
}

// Utility function for the shortest formatting dates
export function formatEventShortDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  return `${day}-${i18n.t(month)}`;
}

export function isTodayBeforeTheStartDate(start) {
  // Get today's date
  const today = new Date();

  // Convert the startDate string to a Date object
  const startDate = new Date(start);

  //console.log(today, "<", startDate, "result=", (today < startDate));

  // Compare the two dates
  return today < startDate;
}

//Formatted printing of file sizes from a given formData object
export function printFileSizesOfFormData(uploadFormData) {
  // Initialize a variable to store the total size
  let totalSize = 0;

  console.log(
    `\n${"File Name".padEnd(
      40
    )}Size\n--------------------------------------------------`
  );
  // Loop through uploadFormData entries
  for (const entry of uploadFormData.entries()) {
    ////display key-value pairs
    //console.log("Key:", entry[0]);
    //console.log("Value:", entry[1]);

    if (entry[1] instanceof File) {
      const fileName = entry[1].name;
      const fileSize = formatFileSize(entry[1].size);
      // console.log(fileName.padEnd(40) + fileSize);

      // Add the size of the file to the totalSize variable
      totalSize += entry[1].size;
    }
  }
  // Print the total size in a human-readable format (e.g., in kilobytes)
  // console.log(
  //   "--------------------------------------------------\n" +
  //     "Total Size:".padEnd(40) +
  //     formatFileSize(totalSize) +
  //     "\n\n"
  // );

  // Helper function to format file size in human-readable format
  function formatFileSize(sizeInBytes) {
    if (sizeInBytes < 1024) {
      return sizeInBytes + " B";
    } else if (sizeInBytes < 1024 * 1024) {
      return (sizeInBytes / 1024).toFixed(2) + " KB";
    } else if (sizeInBytes < 1024 * 1024 * 1024) {
      return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
    } else {
      return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
  }
}

// Function to set the selected language in local storage
export function setLanguage(lang) {
  //console.log("setLanguage:", lang);
  localStorage.setItem("selectedLanguage", lang);
}

// Function to get the selected language from local storage
export function getLanguage() {
  const lang = localStorage.getItem("selectedLanguage");
  //console.log("getLanguage:", lang);
  return lang || "gb"; //return lang if exists or return gb (Great Britain - english)
}

//export function paginationPartsTranslate(){
//  //translate the pagination jumper "Go to page"
//  let goTo = document.getElementsByClassName('el-pagination__jump')[0];
//  if (goTo) {
//    //console.log("Found goto:", goTo);
//    //goTo.childNodes[0].nodeValue = 'text';
//    goTo.textContent = this.$t("go_to");
//  }

//// remove the "/page" or translate it
//// Replace 'afterSlash' with the actual value you want to use
//const afterSlash = '';

//// Get all elements with the class 'el-select-dropdown__item'
//const dropdownItems = document.querySelectorAll('.el-select-dropdown__item');

//// Loop through the elements and update the text of the span based on your condition
//dropdownItems.forEach((item) => {
//  const span = item.querySelector('span');
//  if (span && span.textContent.includes('page')) {
//    span.textContent = span.textContent.split('/page')[0] + afterSlash;
//  }
//});

//// Find the <div> element by its class name
//const elInputDiv = document.querySelector('.el-input.el-input--mini.el-input--suffix');

//console.log("elInputDiv:", elInputDiv);
//if (elInputDiv) {
//  // Find the <input> element within the <div>
//  const inputElement = elInputDiv.querySelector('input');

//  console.log("inputElement:", inputElement);
//  if (inputElement) {
//    // Change the value of the <input> element
//    inputElement.value = inputElement.value.split('/page')[0] + afterSlash;
//  }
//}
//}

/////////////////Cookie functions //////////////////
let cookieName = "absent-cookie-policy-consent";
//let cookieLifetime = 365;
/**
 * Set a cookie
 * @param name - cookie name
 * @param value - cookie value
 * @param expireDays - expiry in days
 */
export function _setCookie(name, value, expireDays) {
  let d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * Get a cookie
 * @param name - cookie name
 * @returns string
 */
export function _getCookie(name) {
  name = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Should the cookie popup be shown?
 */
export function _shouldShowPopup() {
  if (_getCookie(cookieName)) {
    return false;
  } else {
    return true;
  }
}

/////////////End of Cookie Functions ///////////////
